export const authInputStyle = {
  width: '100%', padding: '14px 15px', borderRadius: 12,
  border: '1px solid rgba(255,255,255,0.1)',
  background: 'rgba(0,0,0,0.24)', color: '#fff',
  fontSize: 14, fontFamily: "'Space Grotesk', sans-serif",
  boxSizing: 'border-box', outline: 'none', marginBottom: 12, display: 'block',
};

export const authSocialButtonStyle = {
  width: '100%', padding: '13px', borderRadius: 12,
  border: '1px solid rgba(255,255,255,0.1)',
  background: 'rgba(255,255,255,0.08)', color: '#fff',
  fontSize: 14, fontWeight: 600, cursor: 'pointer',
  fontFamily: "'Space Grotesk', sans-serif",
  display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 10,
  transition: 'all .2s',
};
